module.exports = __webpack_public_path__ + "static/media/screenshot1.f877045e.png";